import { Injectable } from '@angular/core';
import { UpdatePassword } from './UpdatePassword';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiRoutes } from 'src/app/config/api-routes';
import { HttpHeadersService } from '../shared/service/http-headers.service';

@Injectable()
export class AccountService {

  constructor(
    private httpClient: HttpClient,
    private config: ApiRoutes,
    private headersService: HttpHeadersService,
    ) {
  }

  public updatePasswordAndAgreeLicense(updatePassword: UpdatePassword) {
    return this.httpClient.post(this.config.UPDATE_PASSWORD_AND_AGREE_LICENSE, updatePassword);
  }

  public agreeLicenseOnly(confirmationCode: string) {
    return this.httpClient.get(ApiRoutes.getRouteWithInjectedParams(this.config.AGREE_LICENSE, [confirmationCode]));
  }

  public getLoginByConfirmationCodeAndConfirm(confirmationCode: string) {
    let headers = new HttpHeaders();
    headers = this.headersService.disableGlobalErrorHandler(headers);
    const urlWithParams = ApiRoutes.getRouteWithInjectedParams(this.config.GET_LOGIN_BY_CONFIRMATION_CODE, [confirmationCode]);

    return this.httpClient.get(urlWithParams, { headers });
  }
}
